<div class="form-field">
  @if (name) {
    <label class="label" [class.bold]="bold" [attr.for]="inputId">
      <span>{{name}}</span>
    </label>
  }
  <input
    [id]="inputId"
    [formControl]="control"
    [placeholder]="placeholder"
    [preferredCountries]="preferredCountries"
    class="form-control valid-icon invalid-icon"
    autocomplete="off"
    type="tel"
    nomItiPhoneInput
    >
  <div class="actions">
    <ng-content></ng-content>
  </div>
  @if (showError) {
    <div class="input-error">
      <span>{{errorPresentation}}</span>
    </div>
  }
</div>
